module.exports = __webpack_public_path__ + "static/media/adventurerActive.f244180d.png";